import { render, staticRenderFns } from "./details_xq.vue?vue&type=template&id=0f59386b&scoped=true&"
import script from "./details_xq.vue?vue&type=script&lang=js&"
export * from "./details_xq.vue?vue&type=script&lang=js&"
import style0 from "./details_xq.vue?vue&type=style&index=0&id=0f59386b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f59386b",
  null
  
)

export default component.exports